import Autocomplete from './components/Autocomplete';

export default Autocomplete;


// WEBPACK FOOTER //
// ./src/lib/index.js